import Splide from "@splidejs/splide"
import { qsa } from "./utils"

export const initSearchResultsSlider = () => {
  const sliders = qsa("[data-search-results-slider]")

  sliders.forEach((slider) => {
    const splide = new Splide(slider, {
      type: "slide",
      pagination: false,
      width: "100%",
      padding: 0,
      fixedHeight: false,
      autoHeight: true,
      updateOnMove: true,
      lazyLoad: "nearby",
      gap: "1.5rem",
      snap: true,
      autoplay: false,
      perPage: 1,
      mediaQuery: "min",
      breakpoints: {
        640: {
          perPage: 2,
          autoHeight: false,
        },
      },
    })

    splide.mount()
  })
}
